
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organize-a-gamy",
      function () {
        return require("private-next-pages/organize-a-gamy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organize-a-gamy"])
      });
    }
  